// this file is intentionally left blank for the purposes of upgrading to SDK 52 via `npx expo install expo@next|latest --fix`.
// The upgrade of the `expo` package is completed under the old CLI version, which expects this file.
